import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'

import {
  ASSESSMENT_GROUP_FIELD,
  COMMENT_FIELD,
  SCORE_FIELD,
  SKILL_RANGE,
} from '../../model'

import styles from './SummaryAssessmentForm.module.scss'

export const SummaryAssessmentForm = ({
  className = undefined,
  control,
  fields,
  skillTitles,
  watch,
}) => {
  const length = R.length(fields)

  return (
    <Form
      className={cx(styles.assessment, { [className]: Boolean(className) })}
    >
      {R.pipe(
        R.addIndex(R.map)(({ id, key }, index) => {
          const count = index + 1

          const score = watch(
            `${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`,
          )

          return (
            <Box className={styles.content} direction="column" key={id}>
              <span className={styles.count}>{t`${count} of ${length}`}</span>
              <h3 className={styles.title}>{skillTitles[key]}</h3>
              <Box align="center" className={styles.score} justify="center">
                {R.pipe(
                  R.add(1),
                  R.range(1),
                  R.map(value => (
                    <Form.Field
                      className={styles.field}
                      id={`${id}-score-${value}`}
                      field="score"
                      key={value}
                      label={value}
                      labelSize="medium"
                      name={`${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`}
                      score={value}
                      isScoreActive={R.equals(Number(score), value)}
                      {...{ control }}
                    />
                  )),
                )(SKILL_RANGE)}
              </Box>
              <Form.Field
                field="textarea"
                fieldClassName={styles.textarea}
                label={t`Notes`}
                name={`${ASSESSMENT_GROUP_FIELD}[${index}].${COMMENT_FIELD}`}
                isOptional
                {...{ control }}
              />
            </Box>
          )
        }),
      )(fields)}
    </Form>
  )
}
